 const TransactionsLists = [

    {activityDate: "6/03/2020", vendorName:"Circle K",gallons:"18 Gallons", expense:32.00},
    {activityDate: "6/03/2020", vendorName:"Landers",gallons:"12 Gallons", expense:16.00},
    {activityDate: "6/03/2020", vendorName:"Fuel z",gallons:"8 Gallons", expense:12.00},
    {activityDate: "6/03/2020", vendorName:"Kenny's",gallons:"22 Gallons", expense:42.00},
    {activityDate: "6/03/2020", vendorName:"Duets",gallons:"6 Gallons", expense:2.00}
]

export default TransactionsLists;